import { render, staticRenderFns } from "./quiz-status-block.vue?vue&type=template&id=4fa440e4&"
import script from "./quiz-status-block.vue?vue&type=script&lang=js&"
export * from "./quiz-status-block.vue?vue&type=script&lang=js&"
import style0 from "./quiz-status-block.vue?vue&type=style&index=0&id=4fa440e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports